import React from 'react';
import { ShoppingBagIcon, ShirtIcon, UtensilsIcon, PlaneIcon, LaptopIcon, GamepadIcon, HeartIcon, MoreHorizontalIcon } from 'lucide-react';
export const CategoriesRow = ({
  activeCategory,
  setActiveCategory
}) => {
  const categories = [{
    id: 'groceries',
    name: 'Groceries',
    icon: <ShoppingBagIcon size={18} data-id="element-13" />
  }, {
    id: 'fashion',
    name: 'Fashion',
    icon: <ShirtIcon size={18} data-id="element-14" />
  }, {
    id: 'food',
    name: 'Food',
    icon: <UtensilsIcon size={18} data-id="element-15" />
  }, {
    id: 'travel',
    name: 'Travel',
    icon: <PlaneIcon size={18} data-id="element-16" />
  }, {
    id: 'electronics',
    name: 'Electronics',
    icon: <LaptopIcon size={18} data-id="element-17" />
  }, {
    id: 'games',
    name: 'Games',
    icon: <GamepadIcon size={18} data-id="element-18" />
  }, {
    id: 'spa',
    name: 'Spa',
    icon: <HeartIcon size={18} data-id="element-19" />
  }, {
    id: 'more',
    name: 'More',
    icon: <MoreHorizontalIcon size={18} data-id="element-20" />
  }];
  return <section className="mb-8" data-id="element-21">
      <h2 className="text-lg font-bold mb-3" data-id="element-22">Categories</h2>
      <div className="flex overflow-x-auto pb-2 -mx-1 hide-scrollbar" data-id="element-23">
        {categories.map(category => <button key={category.id} onClick={() => setActiveCategory(category.id)} className={`flex flex-col items-center justify-center min-w-[80px] mx-1 px-2 py-3 rounded-lg border ${activeCategory === category.id ? 'bg-gray-100 border-gray-300' : 'bg-white border-gray-200'}`} data-id="element-24">
            <div className="mb-1" data-id="element-25">{category.icon}</div>
            <span className="text-xs" data-id="element-26">{category.name}</span>
          </button>)}
      </div>
    </section>;
};